import React, { useEffect, useState } from 'react';
import AsDropdown from '../../generic/adserve-react-components/AsDropdown/AsDropdown';

export const networkType = {
    ALL: 0,
    NETWORK: 1,
    SUBNETWORK: 2,
    STATION: 3
};

const LogSelection = ({
    selectedStations = [],
    id = 'logSelection',
    inputStyle,
    labelStyle,
    containerStyle,
    name,
    onApply,
    onChange,
    title,
    networks,
    width
}) => {
    const [localSelectedStations, setlocalSelectedStations] = useState([]);

    const [selectionText, setSelectionText] = useState('Select...');
    const [networkList, setNetworkList] = useState([]);

    useEffect(() => {
        const networksArray = [];

        networksArray.push({
            id: 0,
            name: 'All',
            type: networkType.ALL,
            style: {
                fontWeight: 'bold'
            }
        });

        for (let i = 0; i < networks.length; i++) {
            if (
                networksArray.findIndex((x) => x.id === networks[i].id) === -1
            ) {
                networksArray.push({
                    id: networks[i].id,
                    name: networks[i].name,
                    type: networkType.NETWORK,
                    style: {
                        fontWeight: 'bold'
                    }
                });
            }

            for (let j = 0; j < networks[i].subNetworks.length; j++) {
                if (
                    networksArray.findIndex(
                        (x) => x.id === networks[i].subNetworks[j].subNetworkId
                    ) === -1
                ) {
                    networksArray.push({
                        id: networks[i].subNetworks[j].subNetworkId,
                        name: networks[i].subNetworks[j].subNetwork.name,
                        type: networkType.SUBNETWORK,
                        parentId: networks[i].id,
                        style: {
                            marginLeft: 22,
                            fontWeight: 'bold'
                        }
                    });
                }

                for (
                    let k = 0;
                    k <
                    networks[i].subNetworks[j].subNetwork.subNetworkStations
                        .length;
                    k++
                ) {
                    if (
                        networksArray.findIndex(
                            (x) =>
                                x.id ===
                                networks[i].subNetworks[j].subNetwork
                                    .subNetworkStations[k].stationId
                        ) === -1
                    ) {
                        networksArray.push({
                            id: networks[i].subNetworks[j].subNetwork
                                .subNetworkStations[k].stationId,
                            name: networks[i].subNetworks[j].subNetwork
                                .subNetworkStations[k].station.name,
                            type: networkType.STATION,
                            parentId: networks[i].subNetworks[j].subNetworkId,
                            style: {
                                marginLeft: 33
                            }
                        });
                    }
                }
            }
        }

        setNetworkList(networksArray);
    }, [networks]);

    useEffect(() => {
        if (selectedStations.length > 0 && networkList.length > 0) {
            // Update localSelectedStations including the networks and subnetworks
            // Make sure the object has a type (if not get it from the network list)
            let mutar = [];

            selectedStations?.forEach((station) => {
                if (station.type) {
                    mutar = handleTickBoxUpdate(mutar, station);
                } else {
                    const stationToAdd = networkList.find(
                        (x) => x.id === station.id
                    );
                    mutar = handleTickBoxUpdate(mutar, stationToAdd);
                }
            });

            setlocalSelectedStations(mutar);
            updateSelectionText(mutar);
        }
    }, [selectedStations, networkList]);

    // This handles all the logic for making sure the hierarcy is correctly reflected
    const handleTickBoxUpdate = (tickboxItems, selectedEntry) => {
        const addParent = (entityId) => {
            const parents = networkList.filter((x) => x.id === entityId);
            const parentIds = parents.map((x) => x.parentId);

            parentIds?.forEach((parentId) => {
                if (!parentId) {
                    return;
                }

                const children = networkList.filter(
                    (x) => x.parentId === parentId
                );
                const childIds = children.map((x) => x.id);
                const selectedChildren = tickboxItems.filter((x) =>
                    childIds.includes(x.id)
                );

                if (children.length === selectedChildren.length) {
                    const network = networkList.find((x) => x.id === parentId);
                    tickboxItems.push(network);
                }
            });

            parents?.forEach((parent) => {
                if (parent.parentId) {
                    addParent(parent.parentId);
                }
            });
        };

        const removeParent = (entityId) => {
            const parents = networkList.filter((x) => x.id === entityId);
            const parentIds = parents.map((x) => x.parentId);

            const result = tickboxItems.filter(
                (x) => !parentIds.includes(x.id)
            );
            tickboxItems = result;

            parents?.forEach((parent) => {
                if (parent.parentId) {
                    removeParent(parent.parentId);
                }
            });
        };

        const addChildren = (parentId) => {
            const children = networkList.filter((x) => x.parentId === parentId);

            children?.forEach((child) => {
                if (tickboxItems.findIndex((x) => x.id === child.id) === -1) {
                    tickboxItems.push(child);

                    if (
                        networkList.findIndex(
                            (x) => x.parentId === child.id
                        ) !== -1
                    ) {
                        addChildren(child.id);
                    }
                }
            });
        };

        const removeChildren = (parentId) => {
            const childIds = networkList
                .filter((x) => x.parentId === parentId)
                .map((x) => x.id);

            const result = tickboxItems.filter((x) => !childIds.includes(x.id));
            tickboxItems = result;

            childIds?.forEach((childId) => {
                if (
                    networkList.findIndex((x) => x.parentId === childId) !== -1
                ) {
                    removeChildren(childId);
                }
            });
        };

        const i = tickboxItems.findIndex((x) => x?.id === selectedEntry?.id);

        if (i > -1) {
            switch (selectedEntry?.type) {
                case networkType.ALL:
                    tickboxItems = [];
                    break;
                case networkType.NETWORK:
                    tickboxItems.splice(i, 1);
                    removeChildren(selectedEntry.id);
                    break;
                case networkType.SUBNETWORK:
                    tickboxItems.splice(i, 1);
                    removeChildren(selectedEntry.id);
                    removeParent(selectedEntry.id);
                    break;
                case networkType.STATION:
                    tickboxItems.splice(i, 1);
                    removeParent(selectedEntry.id);
                    break;
            }
        } else {
            switch (selectedEntry?.type) {
                case networkType.ALL:
                    {
                        const topLevel = networkList.filter(
                            (x) => x.type === networkType.NETWORK
                        );
                        tickboxItems = [];
                        topLevel?.forEach((entity) => {
                            addChildren(entity.id);
                            tickboxItems.push(entity);
                        });
                        tickboxItems.push(selectedEntry);
                    }
                    break;
                case networkType.NETWORK:
                    addChildren(selectedEntry.id);
                    tickboxItems.push(selectedEntry);
                    break;
                case networkType.SUBNETWORK:
                    addChildren(selectedEntry.id);
                    tickboxItems.push(selectedEntry);
                    addParent(selectedEntry.id);
                    break;
                case networkType.STATION:
                    tickboxItems.push(selectedEntry);
                    addParent(selectedEntry.id);
                    break;
            }
        }

        // To allow this to work without a hierarchy check here if all should be checked or unchecked based on stations
        const topLevel = tickboxItems.filter(
            (x) => x.type === networkType.STATION
        );

        const networkListTopLevel = networkList.filter(
            (x) => x.type === networkType.STATION
        );

        const allIndex = tickboxItems.findIndex(
            (x) => x.type === networkType.ALL
        );
        if (topLevel.length === networkListTopLevel.length) {
            const all = networkList.find((x) => x.type === networkType.ALL);

            if (allIndex === -1) {
                tickboxItems.push(all);
            }
        } else {
            if (allIndex > -1) {
                tickboxItems.splice(allIndex, 1);
            }
        }

        return tickboxItems;
    };

    const handleTick = (selectedEntry) => {
        let mutar = [...localSelectedStations];
        mutar = handleTickBoxUpdate(mutar, selectedEntry);
        setlocalSelectedStations(mutar);
    };

    const updateSelectionText = (stationlist) => {
        const stations = stationlist.filter(
            (x) => x.type === networkType.STATION
        );

        if (stations.length === 0) {
            setSelectionText('Select...');
        } else if (stations.length === 1) {
            setSelectionText(stations[0].name);
        } else {
            const allStations = networkList.filter(
                (x) => x.type === networkType.STATION
            );

            if (stations.length === allStations.length) {
                setSelectionText('All');
            } else {
                setSelectionText(`Multiple (${stations.length} stations)`);
            }
        }

        return stations;
    };

    const handleApply = () => {
        const stations = updateSelectionText(localSelectedStations);

        if (onApply) {
            onApply(stations);
        }
    };

    return (
        <AsDropdown
            id={id}
            activeValues={localSelectedStations}
            onChange={onChange}
            onApply={handleApply}
            onTick={handleTick}
            value={selectionText}
            values={networkList}
            maxVisibleLength={557}
            title={title}
            name={name}
            inputStyle={inputStyle}
            labelStyle={labelStyle}
            containerStyle={containerStyle}
            tongueStyle={{ zIndex: 250 }}
            width={width}
        />
    );
};

export default LogSelection;
